import { apiClient } from "../api/ApiClient";

const CartsApiService = {
  // Get user's cart
  getCart: async () => {
    try {
      const response = await apiClient.get("api/cart");
      return response.data;
    } catch (error) {
      console.error("Error fetching cart:", error);
      throw error;
    }
  },

  // Add item to cart
  addToCart: async (productVariantId, quantity, withoutBox = false) => {
    try {
      const response = await apiClient.post("api/cart/add", {
        productVariantId,
        quantity,
        withoutBox,
      });
      return response.data;
    } catch (error) {
      console.error("Error adding to cart:", error);
      throw error;
    }
  },

  // Update cart item quantity by item ID
  updateCartItem: async (itemId, quantity, withoutBox = false) => {
    try {
      const response = await apiClient.put(`api/cart/items/${itemId}?withoutBox=${withoutBox}`, {
        quantity,
      });
      return response.data;
    } catch (error) {
      console.error("Error updating cart item:", error);
      throw error;
    }
  },

  // Update cart item quantity by variant ID (alternative method)
  updateCartItemByVariant: async (variantId, quantity, withoutBox = false) => {
    try {
      // First, get the cart to find the item ID
      const cart = await CartsApiService.getCart();
      const item = cart.items.find(
        (item) => item.variant.id === variantId && 
        (withoutBox ? item.withoutBoxQuantity > 0 : item.quantity > 0)
      );
      
      if (!item) {
        throw new Error("Cart item not found");
      }
      
      return await CartsApiService.updateCartItem(item.id, quantity, withoutBox);
    } catch (error) {
      console.error("Error updating cart item by variant:", error);
      throw error;
    }
  },

  // Remove item from cart
  removeFromCart: async (variantId, withoutBox = false) => {
    try {
      // First, get the cart to find the item ID
      const cart = await CartsApiService.getCart();
      const item = cart.items.find(
        (item) => item.variant.id === variantId &&
        (withoutBox ? item.withoutBoxQuantity > 0 : item.quantity > 0)
      );
      
      if (!item) {
        throw new Error("Cart item not found");
      }
      
      const response = await apiClient.delete(`api/cart/items/${item.id}?withoutBox=${withoutBox}`);
      return response.data;
    } catch (error) {
      console.error("Error removing from cart:", error);
      throw error;
    }
  },

  // Clear entire cart
  clearCart: async () => {
    try {
      const response = await apiClient.delete("api/cart/clear");
      return response.data;
    } catch (error) {
      console.error("Error clearing cart:", error);
      throw error;
    }
  },

  // Sync local cart with backend
  syncCart: async (cartItems) => {
    try {
      const response = await apiClient.post("api/cart/sync", cartItems);
      return response.data;
    } catch (error) {
      console.error("Error syncing cart:", error);
      throw error;
    }
  },

  // Check item availability
  checkAvailability: async (productVariantId, quantity, withoutBox = false) => {
    try {
      const response = await apiClient.post("api/cart/check-availability", {
        productVariantId,
        quantity,
        withoutBox,
      });
      return response.data;
    } catch (error) {
      console.error("Error checking availability:", error);
      throw error;
    }
  },

  // Get cart item count
  getCartItemCount: async () => {
    try {
      const response = await apiClient.get("api/cart/count");
      return response.data;
    } catch (error) {
      console.error("Error getting cart count:", error);
      throw error;
    }
  },
};

export default CartsApiService;